import { render, staticRenderFns } from "./OverSrgAltr.vue?vue&type=template&id=ef6bc500&"
import script from "./OverSrgAltr.vue?vue&type=script&lang=js&"
export * from "./OverSrgAltr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports